import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryNameSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M4 13.5V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H14.5L20 7.5V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H12.5"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 2V8H20"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.42 12.6102C10.615 12.4152 10.8465 12.2605 11.1013 12.155C11.3561 12.0494 11.6292 11.9951 11.905 11.9951C12.1808 11.9951 12.4539 12.0494 12.7087 12.155C12.9635 12.2605 13.195 12.4152 13.39 12.6102C13.585 12.8052 13.7397 13.0368 13.8452 13.2915C13.9508 13.5463 14.0051 13.8194 14.0051 14.0952C14.0051 14.371 13.9508 14.6441 13.8452 14.8989C13.7397 15.1537 13.585 15.3852 13.39 15.5802L7.95 21.0002L4 22.0002L4.99 18.0502L10.42 12.6102Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default TaskHistoryNameSVG;
